import {
	LocalOfferOutlined,
	LockOutlined,
	PersonOutlined,
	SettingsOutlined,
	Speed,
	SupportAgent,
} from '@mui/icons-material';
import { FC, ReactNode, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ProfileButton, UserProfile } from '../../components';
import { useUserStore } from '../../stores';
import { UserRole } from '../../utils';
import { Container, PageContent, ProfileAside, ProfilePages, Separator } from './MyAccount.styles';

interface MyAccountProps {
	children: ReactNode;
}

const commonPages = [
	{
		name: 'Alterar Senha',
		path: '/minha-conta/alterar-senha',
		icon: <LockOutlined fontSize='inherit' />,
	},
	{
		name: 'Suporte',
		path: '/minha-conta/suporte',
		icon: <SupportAgent fontSize='inherit' />,
	},
];

const dealerPages = [
	{
		name: 'Concessionárias',
		path: '/minha-conta',
		icon: <Speed fontSize='inherit' />,
	},
	{
		name: 'Meus Dados',
		path: '/minha-conta/meus-dados',
		icon: <PersonOutlined fontSize='inherit' />,
	},
	...commonPages,
	{
		name: 'Configurações',
		path: '/minha-conta/configuracoes',
		icon: <SettingsOutlined fontSize='inherit' />,
	},
];

const shopkeeperPages = [
	{
		name: 'Minhas Compras/Ofertas',
		path: '/minha-conta/lojista',
		icon: <LocalOfferOutlined fontSize='inherit' />,
	},
	{
		name: 'Meus Dados',
		path: '/minha-conta/meus-dados',
		icon: <PersonOutlined fontSize='inherit' />,
	},
	...commonPages,
	{
		name: 'Configurações',
		path: '/minha-conta/configuracoes',
		icon: <SettingsOutlined fontSize='inherit' />,
	},
];

const adminPages = [
	{
		name: 'Meus Dados',
		path: '/minha-conta',
		icon: <PersonOutlined fontSize='inherit' />,
	},
	...commonPages,
];

const MyAccount: FC<MyAccountProps> = ({ children }) => {
	const { user } = useUserStore();
	const location = useLocation();
	const [subPages, setSubPages] = useState(commonPages);

	useEffect(() => {
		const useRole = user?.grupoAcesso.id.toString();

		switch (useRole) {
			case UserRole.Dealer:
				setSubPages(dealerPages);
				break;
			case UserRole.Shopkeeper:
				setSubPages(shopkeeperPages);
				break;
			case UserRole.Admin:
				setSubPages(adminPages);
				break;
			default:
				break;
		}
	}, [user?.grupoAcesso.id]);

	return (
		<Container>
			<ProfileAside>
				<UserProfile user={user!} />
				<Separator />
				<ProfilePages>
					{subPages.map((page) => (
						<Link style={{ width: '100%' }} to={page.path} key={page.name}>
							<ProfileButton
								label={page.name}
								icon={page.icon}
								active={page.path === location.pathname}
							/>
						</Link>
					))}
				</ProfilePages>
			</ProfileAside>
			<PageContent>{children}</PageContent>
		</Container>
	);
};

export default MyAccount;
